/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { connect } from 'react-redux';
import CreationModule from "../CreationModule";
import set from "lodash/set";
import unset from "lodash/unset";
import forEach from "lodash/forEach";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import NotificationPreview from "../NotificationPreview";
import {
    calculateTarget,
    createNotification,
    deleteNotification,
    getAllNotifications
} from "../../../actions/entities/notificationsCenter";
import swal from "sweetalert2";
import {getParameterByName} from "../../../helpers/location";
import {scrollToTop} from "../../../helpers/utils";
import TargetingQueries from "../../../components/TargetingQueries";
import '../index.css'

class notificationCreate extends React.Component {
    state = {
        data: {},
        targetFields: {},
        counts: null,
        loading: false,
        targetQuery: null,
    };

    componentDidMount() {
        const { dispatch, list } = this.props;
        if (getParameterByName('duplicate', window.location.href)) {
            if (list) this.setState({ data: list[getParameterByName('duplicate', window.location.href)] });
            else {
                dispatch(getAllNotifications());
            }
        }
        scrollToTop();
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.list && this.props.list) {
            this.setState({ data: this.props.list[getParameterByName('duplicate', window.location.href)] })
        }
    }

    onChangeInput = (value, keys) => {
        this.setState({ data: set(this.state.data, keys, value || value === false ? value : undefined) });
    };

    clean(object) {
        Object
            .entries(object)
            .forEach(([k, v]) => {
                if (v && typeof v === 'object') {
                    this.clean(v);
                }
                if ((v && typeof v === 'object' && !Object.keys(v).length) || v === null || v === undefined) {
                    if (Array.isArray(object)) {
                        object.splice(k, 1);
                    } else {
                        delete object[k];
                    }
                }
            });
        return object;
    }

    createNotification = () => {
        const { data, targetFields } = this.state;
        const { dispatch } = this.props;
        const compactData = this.clean(cloneDeep(data));
        const onError = (error) => swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${error}<br/>`,
        });
        const onSuccess = (response) => {
            this.props.history.push(`/notification/modify/${response.id}`);
        };
        dispatch(createNotification({ ...compactData, targetFields }, onSuccess, onError));
    };

    checkDelete(notificationId) {
        const { dispatch } = this.props;
        swal({
            title: 'Are you sure ?',
            type: 'info',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText:
                'Yes',
            cancelButtonText:
                'No',
        }).then(() => {
            dispatch(deleteNotification(notificationId));
        }).catch(error => {
            console.log(error);
        })
    }

    onChangeTargetingData = (value, key) => {
        this.setState({ targetFields: set(this.state.targetFields, key, value) });
    };

    deleteTargetingQuery = (key) => {
        const freshData = this.state.targetFields;
        unset(freshData, key);
        const parentKey = key.split('.');
        parentKey.splice(key.split('.').length - 1, 1);
        const parent = get(freshData, parentKey.join('.')) || freshData;
        const normalize = (object) => {
            let i = 1;
            const newParent = {};
            forEach(object, o => {
                newParent[i] = o;
                if (i === 1) delete newParent[i].operator;
                i++;
            });
            set(freshData, parentKey, newParent);
        };
        normalize(parent);
        this.setState({ targetFields: freshData });
    };

    addTargetingQuery = (key) => {
        const freshData = this.state.targetFields;
        let parent = get(freshData, key);
        if (parent.type === 'group') {
            if (!Object.keys(parent.fields).length) {
                parent = {
                    type: "field",
                    name: "id",
                    fieldType: "string",
                    operation:  "equal",
                    parameter: ""
                };
                set(freshData, key, parent);
            } else {
                const needOperator = Object.keys(parent.fields).length >= 1 || undefined;
                parent.fields[Object.keys(parent.fields).length ? parseInt(Object.keys(parent.fields)[Object.keys(parent.fields).length - 1], 10) + 1 : 1] = {
                    operator: needOperator && 'AND',
                    type: "field",
                    name: "id",
                    fieldType: "string",
                    operation:  "equal",
                    parameter: ""
                };
            }
        } else {
            parent = {
                type: 'group',
                operator: parent.operator,
                fields: {
                    1: {
                        ...parent,
                        type: 'field',
                        operator: undefined
                    },
                    2: {
                        operator: "AND",
                        type: "field",
                        name: "id",
                        fieldType: "string",
                        operation:  "equal",
                        parameter: ""
                    }
                }
            };
            set(freshData, key, parent);
        }
        this.setState({ targetFields: freshData });
    };

    addFirstQuery() {
        this.setState({
            targetFields: {
                1: {
                    type: "field",
                    name: "id",
                    fieldType: "string",
                    operation:  "equal",
                    parameter: ""
                },
            }
        })
    }

    addCustomQuery() {
        this.setState({
            targetQuery: '',
        })
    }

    onChangeOperator = (key) => {
        const freshData = this.state.targetFields;
        const parent = get(freshData, key);
        parent.operator = parent.operator === 'AND' ? 'OR' : 'AND';
        this.setState({ targetFields: freshData });
    };

    calculateTarget = (type) => {
        const { dispatch } = this.props;
        const { data } = this.state;
        const onSuccess = (response) => {
            this.setState({ counts: response, loading: false });
        };
        const onError = (error) => {
            this.setState({ loading: false });
            swal({
                title: `Oops...`,
                type: 'error',
                html: `Something went wrong !<br/>${error}<br/>`,
            });
        };
        const onRequest = () => this.setState({ loading: true });
        dispatch(calculateTarget({ [type]: this.state[type] , optinType: data.notificationType }, onSuccess, onError, onRequest));
    };

    render() {
        const { data, targetFields, loading, targetQuery } = this.state;

        return (
            <div id="notificationCreate">
                <header className="content-header">
                    <h1>
                        Notification MPG
                        <small>create</small>
                    </h1>
                </header>
                <section className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <CreationModule
                                data={data}
                                onChangeInput={this.onChangeInput}
                                isCreate
                            />
                            <NotificationPreview data={data} />
                        </div>
                        <div className="col-md-12">
                            <div id="targetingQueries" className="box box-default">
                                <div className="box-header with-border">
                                    <h3 className="box-title pull-left">
                                        Targeting: <a href="https://docs.google.com/spreadsheets/d/1567fjuysyUYywDF5PIBG6Xin1vBryTDVbfkYnFL82BM/edit#gid=0" target="_blank">liste des variables</a>
                                    </h3>
                                </div>
                                <div className="p-5">
                                    {
                                        !!Object.keys(targetFields).length && (
                                            <React.Fragment>
                                                <div className="text-center countsContainer" style={{ minHeight: '50px' }}>
                                                    {loading ? <i style={{ fontSize: '24px' }} className="fa fa-spin fa-circle-o-notch"/> : (
                                                        <button
                                                            disabled={!data.notificationType}
                                                            onClick={() => this.calculateTarget('targetFields')}
                                                            className="btn btn-success"
                                                        >
                                                            Calculate
                                                        </button>
                                                    )}
                                                    {this.state.counts && !loading && (
                                                        <React.Fragment>
                                                            <div style={{ margin: '0 20px' }}>
                                                                <div className="m-3">Target volume users :</div>
                                                                <div className="count">{this.state.counts.totalCount ? this.state.counts.totalCount.toLocaleString() : 0}</div>
                                                            </div>
                                                            <div>
                                                                <div className="m-3">Target Volume users last <br/>connexion 21 days:</div>
                                                                <div className="count">{this.state.counts.recentlyConnectedCount ? this.state.counts.recentlyConnectedCount.toLocaleString() : 0}</div>
                                                            </div>
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                                <TargetingQueries
                                                    onChange={this.onChangeTargetingData}
                                                    data={targetFields}
                                                    onDelete={this.deleteTargetingQuery}
                                                    onAdd={this.addTargetingQuery}
                                                    onChangeOperator={this.onChangeOperator}
                                                />
                                            </React.Fragment>
                                        )
                                    }
                                    {
                                        !!(!Object.keys(targetFields).length && targetQuery === null) && (
                                            <div className="text-center">
                                                <div style={{ marginBottom: '30px' }}>
                                                    <i className="fa fa-plus-circle addIcon" onClick={() => this.addFirstQuery()} />
                                                </div>
                                                <div>
                                                    <div style={{ margin: '10px' }}>Or custom target:</div>
                                                    <i style={{ color: 'red' }} className="fa fa-plus-circle addIcon" onClick={() => this.addCustomQuery()} />
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                                <div>
                                    {
                                        targetQuery !== null && (
                                            <div className="text-center">
                                                <div className="text-center countsContainer" style={{ minHeight: '50px', margin: '20px' }}>
                                                    {loading ? <i style={{ fontSize: '24px' }} className="fa fa-spin fa-circle-o-notch"/> : (
                                                        <button
                                                            disabled={!data.notificationType}
                                                            onClick={() => this.calculateTarget('targetQuery')}
                                                            className="btn btn-success"
                                                        >
                                                            Calculate
                                                        </button>
                                                    )}
                                                    {this.state.counts && !loading && (
                                                        <React.Fragment>
                                                            <div style={{ margin: '0 20px' }}>
                                                                <div className="m-3">Target volume users :</div>
                                                                <div className="count">{this.state.counts.totalCount ? this.state.counts.totalCount.toLocaleString() : 0}</div>
                                                            </div>
                                                            <div>
                                                                <div className="m-3">Target Volume users last <br/>connexion 21 days:</div>
                                                                <div className="count">{this.state.counts.recentlyConnectedCount ? this.state.counts.recentlyConnectedCount.toLocaleString() : 0}</div>
                                                            </div>
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                                <textarea
                                                    className="form-control"
                                                    value={targetQuery}
                                                    onChange={(event) => this.setState({ targetQuery: event.target.value })}
                                                />
                                                <div style={{ margin: '10px' }}>
                                                    <i className="fa fa-trash-o deleteIcon" onClick={() => this.setState({ targetQuery: null })} />
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="text-center p-5">
                    <button onClick={this.createNotification} className="btn btn-success" >Create</button>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        list: state.app.notificationsCenter.list.list,
    }),
    dispatch => ({ dispatch }),
)(notificationCreate);



// WEBPACK FOOTER //
// ./src/pages/Notifications/Create/index.js